import { getProjectStatistics } from "../../../../apis/impact-report/report";
import useFetchData from "../../../../hooks/useFetchData";
import VerticalBarChart from "../../../../ui/VerticalBarChart";
import Loader from "../../../../ui/Loader";
import { useFilters } from "../../../../contexts/FiltersContext";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const data = [
  { name: 'Write a blog about Water Shortage in Bengaluru', numberOfSubmissions: 42 },
  { name: 'Rainwater Harvesting', numberOfSubmissions: 38 },
  { name: 'Composting', numberOfSubmissions: 56 },
  { name: 'Tree Planting Initiative', numberOfSubmissions: 67 },
  { name: 'Plastic Cleanup Drive', numberOfSubmissions: 45 },
  { name: 'Solar Panel Installation', numberOfSubmissions: 23 },
  { name: 'Community Garden Setup', numberOfSubmissions: 34 },
  { name: 'E-waste Collection Campaign', numberOfSubmissions: 29 },
  { name: 'Water Conservation Workshop', numberOfSubmissions: 51 },
  { name: 'Sustainable Transportation Survey', numberOfSubmissions: 38 },
  { name: 'Green Energy Awareness', numberOfSubmissions: 62 },
  { name: 'Local Food Production', numberOfSubmissions: 41 },
  { name: 'Waste Reduction Program', numberOfSubmissions: 33 },
  { name: 'Biodiversity Conservation', numberOfSubmissions: 47 },
  { name: 'Climate Action Campaign', numberOfSubmissions: 55 },
];

const COLORS = ['var(--barFirst-color)', 'var(--barSecond-color)', 'var(--barThird-color)'];

const ActivitiesTab = ({projectId,imageGenerationTimestamp}) => {

  const { selectedPrimary, setFilterOptions } = useFilters()
  const { loading, response, error } = useFetchData(
    getProjectStatistics,
    [projectId,"BOUNTY_WISE_SUBMISSION_COUNT",imageGenerationTimestamp,""],
    [projectId,"BOUNTY_WISE_SUBMISSION_COUNT",imageGenerationTimestamp,""]
  );

  useEffect(()=>{
    if (!loading && response) {
      const list = response?.bountyWiseSubmissionCount?.map(i=>i?.title).filter(Boolean) || []
      setFilterOptions({ label: 'Activities', options: list })
    }
  },[loading, response, setFilterOptions])

  const transformedData = response?.bountyWiseSubmissionCount?.map(item => ({
    name: item?.title,
    value: item?.submissionCount,
    key: item?._id
  }))?.sort((a, b) => b?.value - a?.value) || [];

  const allSelected = !selectedPrimary?.length || selectedPrimary.includes('All')
  const filteredData = allSelected ? transformedData : transformedData.filter(d => selectedPrimary.includes(d.name))

  if (loading) return  <div className='w-full  h-[23.9375rem] flex pt-11 justify-center '  ><Loader/></div> ;
  if(filteredData?.length === 0) return <div className="w-full h-[23.9375rem] flex items-center justify-center text-textPrimary">No data available</div>; 

  return ( 
    <VerticalBarChart
      data={filteredData}
      xAxisLabel="Activities"
      yAxisLabel="No. of submissions"
      barSize={40}
      height={500}
      showReferenceLine={false}
      visibleBars={7}
    />
  );
};

export default ActivitiesTab;